<template>
  <button type="button" class="btn btn-outline-secondary" @click="showModal()"><font-awesome-icon icon="pen" class="me-2" /> Passwort bearbeiten</button>

  <!-- Edit Benutzer Passwort Modal -->
  <div
    class="modal fade"
    :id="'editUserPasswordModal' + index"
    tabindex="-1"
    :aria-labelledby="'editUserPasswordModal' + index"
    aria-hidden="true"
    ref="editUserPasswordModalRef"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2" data-bs-theme="dark">
          <span class="modal-title my-auto text-white" :id="'editUserPasswordModalLabel' + index">Passwort bearbeiten</span>

          <button type="button" class="btn-close btn-sm" @click="closeModal()"></button>
        </div>

        <div class="modal-body" :id="'editUserPasswordModalBody' + index">
          <LoadingSpinner v-if="loading" />

          <form v-else @submit.prevent="savePassword">
            <div class="mb-3">
              <label :for="'editPasswordInput-' + index" class="form-label fw-bold">Neues Passwort</label>
              <input type="password" class="form-control" :id="'editPasswordInput-' + index" v-model="password" autocomplete="new-password" />
            </div>

            <hr class="my-3" />

            <div v-if="errorMsg != ''" class="alert alert-danger mb-3">
              Es ist ein Fehler aufgetreten:<br />
              {{ errorMsg }}
            </div>

            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary me-3" @click="closeModal()">Abbrechen</button>
              <button type="submit" class="btn btn-primary">Speichern</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed, ref } from 'vue';
  import { Modal } from 'bootstrap';
  import { useBenutzerStore } from '@/stores/benutzerStore';
  import { useCommonStore } from '@/stores/commonStore';
  // // import { useAuthStore } from '@/stores/authStore';

  import { User, UserCredentials, ResetUserPasswordRequest } from '@/models/BenutzerModels';

  import LoadingSpinner from '../LoadingSpinner.vue';
  //#endregion

  const props = defineProps({
    user: {
      type: Object as PropType<User>,
      required: true,
    },

    realm: {
      type: String as PropType<string>,
      default: 'admin',
    },

    index: {
      type: Number as PropType<number>,
      required: true,
    },
  });

  // const authStore = useAuthStore();
  const benutzerStore = useBenutzerStore();
  const commonStore = useCommonStore();

  const loading = computed(() => commonStore.status.updateBenutzerLoading);
  const errorMsg = computed(() => commonStore.status.benutzerErrorMsg);

  const password = ref('');

  async function savePassword() {
    const data = new UserCredentials();
    data.value = password.value;
    data.type = 'password';

    await benutzerStore.resetRealmUserPassword(new ResetUserPasswordRequest(props.realm, props.user.id, data));

    if (errorMsg.value == '') {
      closeModal();
    }
  }

  //#region Modal
  const editUserPasswordModalRef = ref();

  function closeModal() {
    Modal.getInstance(editUserPasswordModalRef.value)?.hide();
  }

  function showModal() {
    if (editUserPasswordModalRef.value) {
      password.value = '';
      new Modal(editUserPasswordModalRef.value).show();
    }
  }
  //#endregion
</script>

<style scoped>
  .modal-content {
    background: rgb(242, 243, 248);
  }

  /* .modal-body {
  background: rgb(242, 243, 248);
}

.modal-footer {
  background: rgb(242, 243, 248);
} */
</style>
